import { IRequestService } from "../../service/request/RequestService";

export default class GetRequestTypesInteractor {
  private requestService: IRequestService;

  constructor(requestService) {
    this.requestService = requestService;
  }

  async execute() {
    return this.requestService.getRequestTypes();
  }
}
